define('models/merchants/giftcard_collection',[
    'backbone',
    'models/merchants/giftcard'
], function (Backbone, GiftCard) {

    return Backbone.Collection.extend({
        model: GiftCard,
        url  : function(){

            if(this.instanceURL){
                return this.instanceURL;
            } else {

                if (this.merchantGUID == undefined || this.merchantGUID == null){
                    return pf.consumerURL + '/ecards';  
                } else {
                    return pf.consumerURL + '/ecards?MerchantGUID=' + this.merchantGUID;
                }

            }

        },
        initialize: function(options){
            options = options || {};
            this.instanceURL = options.instanceURL;
            this.merchantGUID = options.merchantGUID;
        }
    });
});
